'use client'

import s from './ServicesList.module.sass'
import cn from 'clsx'

import type { ServicesList as ServicesListType } from '../../../../../apps/benmax/src/types/sanity.types'

import { Copy, Button, ImageBox } from 'shared-components'

import { useState } from 'react'

import { getSanityLink } from 'shared-functions'

function ServicesList({
    title,
    copy,
    link,
    reverse,
    reverseMainSection,
    mainBackgroundColour,
    services,
    fullImages,
}: ServicesListType) {
    const [active, setActive] = useState(0)
    const _link = link?.linkType === 'internal' || link?.linkType === 'external' ? getSanityLink(link) || null : null

    const activeService = services?.[active]
    const { image, title: serviceTitle, copy: serviceCopy } = activeService || {}

    const isLight = mainBackgroundColour === 'light'

    return (
        <section className={cn(s.ServicesList, isLight && s.IsLight)}>
            <div className={cn(s.Cont, 'container', reverse && s.Reverse)}>
                <div className={cn(s.Main, reverseMainSection && s.ReverseMain)}>
                    <div>
                        {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
                        {copy && <Copy copy={copy} size="small" />}
                        {_link && <Button {..._link} inverted={!isLight} transparent />}
                    </div>
                    <ul>
                        {services?.map((service, index) => {
                            const { category } = service
                            return (
                                <li
                                    key={index}
                                    className={cn(s.Item, active === index && s.Active)}
                                    onClick={() => setActive(index)}
                                    aria-label="Click to view service details"
                                >
                                    {category && (
                                        <span
                                            className="smallCaps"
                                            dangerouslySetInnerHTML={{
                                                __html: category,
                                            }}
                                        />
                                    )}
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div className={cn(s.Service, fullImages ? s.FullImage : '')} key={active}>
                    <div className={s.Image}>
                        {image && <ImageBox image={image} alt={serviceTitle} width={850} height={525} />}
                    </div>
                    <div className={s.Content}>
                        {serviceTitle && (
                            <h4
                                dangerouslySetInnerHTML={{
                                    __html: serviceTitle,
                                }}
                            />
                        )}
                        {serviceCopy && <Copy copy={serviceCopy} />}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ServicesList
